import React from 'react';
import TextField from './TextField';
import { NumericCodeFieldProps } from '../models';

const NumericCodeField: React.FC<NumericCodeFieldProps> = (props) => {
  const getFieldError: NumericCodeFieldProps['getFieldError'] = (v) =>
    !v.match(new RegExp(`^[0-9]{${props.maxLength}}$`)) && `Please enter a complete ${props.maxLength}-digit code.`;

  return <TextField type="tel" {...props} getFieldError={getFieldError} controlType="code" />;
};

export default NumericCodeField;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/forms/fields/NumericCodeField.tsx